export default __webpack_public_path__ + "static/media/jsrbrtable_Wdsbg.15867b56.webp";